import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CounterBidDisclosureComponent } from '../counter-bid-disclosure/counter-bid-disclosure.component';

@Component({
  selector: 'app-agent-terms',
  templateUrl: './agent-terms.component.html',
  styleUrls: ['./agent-terms.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,

  imports: [CounterBidDisclosureComponent],
})
export class AgentTermsComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
